import React, { useMemo, useState } from "react";
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { ChipFilter, filtroMultiplo } from "../../../../components/Tabella/ChipFilter";

const data_column = [

	{
		Header: 'Data inizio',
		accessor: 'promo_inizio',
		disableGlobalFilter: true,
	},
	{
		Header: 'Data fine',
		accessor: 'promo_fine',
		disableGlobalFilter: true,
	},
	{
		Header: 'Nome promozione',
		accessor: 'promo_nome',
	},
    {
		Header: 'Prodotti in promo',
		accessor: 'promo_prodotti',
	},

	{
		Header: 'Stato',
		accessor: 'promo_status',
		disableGlobalFilter: true,
		Cell: ({ value }) => {
			return (
				<div className="d-flex align-items-center">
					<i className={`fa fa-circle me-1 ${value.class}`}></i>
					{value.label}
				</div>
			)
		},
		disableFilters: true,
	},
];
const data_json = [

	{
		"promo_inizio": "1 Marzo 2024",
		"promo_fine": "30 giugno 2024",
		"promo_nome": "Summerfest",
        "promo_prodotti": "Lezioni Tennis",
		"promo_status": {
			"label": "Attivo",
			"class": "text-success"
		},
	},
    {
		"promo_inizio": "30 settembre 2023",
		"promo_fine": "30 ottobre 2023",
		"promo_nome": "Bentornati - 5%",
        "promo_prodotti": "Lezioni Nuoto (+altri 10)",
		"promo_status": {
			"label": "Scaduta",
			"class": "text-primary"
		},
	},
    {
		"promo_inizio": "30 settembre 2024",
		"promo_fine": "30 ottobre 2024",
		"promo_nome": "Bentornati - 5%",
        "promo_prodotti": "Lezioni Nuoto (+altri 10)",
		"promo_status": {
			"label": "Programmata",
			"class": "text-blue"
		},
	},
	
];

// Valori del filtro a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Programmata', 'Attivo', 'Scaduta'];

const ListaPromo = () => {
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	const filteredData = useMemo(
		() => data_json.filter((row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row.promo_status?.label)),
		[statoFilter],
	);

	return (
		<TabellaLista
			pageList={true}
			cardTitle={'Promozioni'}
			hasSearch={true}
			searchPlaceholder={'Cerca per promozione o prodotti'}
			hasFilter={false}
			filterControl={
				<div className="sid-chip-filters">
					<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
				</div>
			}
			hasAddMore={true}
			labelAddMore={'Nuova promozione'}
			linkAddMore={'/struttura/prodotti/promozioni/aggiungi'}
			data_column={data_column}
			data_json={filteredData}
		/>
	)
}

export default ListaPromo
